import {MutableRefObject, useEffect} from "react";

export function useDetectOutSideClick(containerRef: MutableRefObject<null | HTMLDivElement>, buttonRef: MutableRefObject<null | HTMLButtonElement | HTMLDivElement>, callback: (toggle?: boolean) => void) {
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (containerRef.current && event.target && !(containerRef.current.contains(event.target as Node) || buttonRef.current?.contains(event.target as Node))) {
        callback(buttonRef.current?.contains(event.target as Node));
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [containerRef, buttonRef, callback]);
}
